// This is typeforward/autocomplete on searchfields that utilizes jQuery UI.
// This setup enables to control html of the dropdown.
(function ($, window) {
    "use strict";

    DSV.ui.autoComplete = {
        init: function () {
            var ac = this;

            $.widget("custom.autocomplete", $.ui.autocomplete, {
                _renderItem: function (ul, item) {
                    //var text = item.label.replace(new RegExp("^"+ item.term, "g"), '<b>'+ item.term +'</b>');
                    var text = ac.highlightSearchWords(item.term, item.label);

                    if (item.text && item.text !== "") {
                        text += "<br />" + ac.highlightSearchWords(item.term, item.text);
                    }

                    var $a = $("<a></a>").html(text);

                    return $('<li><div></div></li>')
                        .append($a)
                        .appendTo(ul);
                }
            });

            $('input.country').each(function () {
                var $inp = $(this),
                    countriesData = $inp.data("countries");

                $inp.autocomplete({
                    minLength: 2,
                    appendTo: "#page",
                    position: {
                        using: function (pos, menu) {
                            //pos.top += 10;
                            $(menu.element.element).css({top: pos.top + "px", left: pos.left + "px"});
                        }
                    },
                    source: countriesData
                });
            });
        }, // ui.autoComplete.init

        highlightSearchWords: function (term, text) {
            return text.replace(new RegExp("(" + term + ")", "gi"), "<b>$1</b>");
        } // ui.autoComplete.highlightSearchWords
    }; // ui.autoComplete
})(jQuery, window);